import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import 'rc-slider/assets/index.css';

import {ButtonCollapseEye, CustomMiniButtonX, GenericTableButton,} from "../../../components/buttons/buttonsActions";
import {error, FORM} from "../../../components/i18n/i18n";
import PropTypes from "prop-types";
import {mapFunctions} from "../../../components/map/mapFunctions";
import {showToastCustom} from "../../../components/toast/customToast";
import {traceService} from "../../../jwt/_services/xeeker/traceService";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {pointService} from "../../../jwt/_services/xeeker/pointService";
import {pointDraggableItemContent} from "../../../components/draggableList/renderContent";
import {DragList} from "../../../components/draggableList/DragList";
import Switch from "react-bootstrap-switch";
import {FL_COLOR} from "../../../components/i18n/formLabels";
import {TT_CLOSE, TT_DELETE, TT_SAVE} from "../../../components/i18n/toolTips";
import MapController from "../../../components/map/MapController";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {userService as pointUdnService} from "../../../jwt/_services";
import MapControllerV2 from "../../../components/map/MapControllerV2";
import Slider from "rc-slider";


const style = {
    float: 'left',
    width: 30,
    height: 100,
};

export const TraceForm = ( { udn, trace, googleMapConfig, fbDataBaseId, onClose, addTrace, setLoading } )  => {
    const [googleConfig] = useState(googleMapConfig || {});
    const [traceId, setTraceId] = useState(trace?.id || null);
    const [points, setPoints] = useState(trace?.points || []);
    const [markers, setMarkers] = useState(mapFunctions.mapPointsToMarkers(trace?.points || []));
    const [markerOptions, setMarkerOptions] = useState([]);

    const [selectedMarker, setSelectedMarker] = useState(null);
    const [status, setStatus] = useState(trace?.status || true);
    const [radio, setRadio] = useState(trace?.ratio || 10);
    const [smoothingDistance, setSmoothingDist] = useState(2.5);
    const [epsilon, setEpsilon] = useState(0.000004);
    const [fileName, setFileName] = useState(null)

    const [modeAddConsec, setModeAddConsec] = useState(false);
    const [showPoints, setShowPoints] = useState(true);
    const [zoom, setZoom] = useState(19);

    useEffect(() => {
        return () => {
        }
    }, [])


    const {handleSubmit, register} = useForm({
        defaultValues: {
            id: trace?.id,
            uid: trace?.uid,
            color: trace?.color,
            ratio: trace?.ratio,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb: true,
            item: {
                ...data,
                points: mapFunctions.mapMarkersToPointsArray(markers, udn, radio),
                udn: {id: udn.id}
            }
        }


        if (modeAddConsec || (trace?.id === undefined || trace?.id === null || trace?.id === '')) {
            return traceService.saveItem(dataRequest)
                .then(result => {
                    if (result)
                        addTrace(result);
                    onClose();
                })
                .catch(errorMessage => {
                    showToastCustom(error, errorMessage);
                })
                .finally(_ => {
                    setLoading(false);
                })
        } else {
            let id = trace.id;
            dataRequest.item.id = trace?.id

            return traceService.updateItem(id, dataRequest)
                .then(_ => {
                    onClose();
                })
                .catch(errorMessage => {
                    showToastCustom(error, errorMessage);
                })
                .finally(_ => {
                    setLoading(false);
                })
        }
    };

    const onDelete = (id, _fbDataBaseId) => {
        setLoading(true);

        traceService.deleteItem(id)
            .then(_ => {
                onClose();
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
            })
            .finally(_ => {
                setLoading(false);
            });
    };

    const confirmDelete = (_) => {
        // valida que trace no sea nulo o indefinido
        if (trace === null || trace === undefined)
            return;

        return ConfirmDelete({
            remove: onDelete,
            data: trace,
            fbDataBaseId: fbDataBaseId
        });
    };


    const onReorder = (_data) => {
        // {from : fromIndex, to : toIndex, list : reorderedList }
        setMarkers(_data.list);
    }

    const onRemovePoint = (index) => {
        let _point = points[index];
        return pointService.deleteItem(_point.id)
    }

    const onRemoveFromList = (index) => {
        let _markers = markers.slice();
        _markers.splice(index, 1);

        setMarkers(_markers);

        const mapedPositions = mapFunctions.mapMarkersToPointsArray(_markers, udn);
        setPoints(mapedPositions);
    }

    const onMapClick = (event) => {
        const newMarker = {
            title: `marker${markers.length + 1}`,
            name: `marker${markers.length + 1}`,
            showOrder: markers.length + 1,
            position: {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
                alt: 0, // Default altitude to 0
            },
        };

        setMarkers([...markers, newMarker]); // Add the new marker to the array
    }

    const onClearMarkers = () => {
        setMarkers([]);
        setPoints([]);
    }

    // Selecciona un marcador desde la lista
    const onSelect = (_value, _data2, _index) => {
        // Find marker on _index and set isSelected = _value
        let _markers = markers.slice();
        if (_markers[_index]) {
            _markers[_index].isSelected = _value;
            setMarkers(_markers);
        }
    }

    // Selecciona un marcador desde el mapa
    const onMarkerClick = (_marker, _index) => {
        // Find marker on _index and set isSelected = _value
        let _markers = markers.slice();
        if (_markers[_index]) {
            _markers[_index].isSelected = !_markers[_index].isSelected;
            setMarkers(_markers);
        }
    }

    // Selecciona un marcador de las opciones cercanas
    const onMarkerOptionClick = (_point) => {
        // Convert point to marker and add to markers list
        let _marker = {
            title: `marker${markers.length + 1}`,
            name: `marker${markers.length + 1}`,
            position: {
                lat: _point.lat,
                lng: _point.lng,
                alt: _point.alt || 0,
            },
            showOrder: markers.length ,
        }
        let _markers = markers.slice();
        // Unselect all markers
        _markers.forEach(marker => marker.isSelected = false);
        // Add new marker to the list
        let newMarker = {
            ..._marker,
            showOrder: _markers.length + 1,
            isSelected: false // Default to not selected
        };
        _markers.push(newMarker);
        setMarkers(_markers);
        setMarkerOptions([]);
    }

    // Crea un nuevo trazo a partir de los puntos seleccionados
    const onNewFromSelection = () => {
        // Check if there are selected markers
        let selectedMarkers = markers.filter(marker => marker.isSelected);

        // If no markers are selected, show a toast message and return
        if (selectedMarkers.length === 0) {
            showToastCustom(error, "No markers selected. Please select markers to create a new trace.");
            return;
        }

        selectedMarkers.forEach(marker => marker.isSelected = false);

        setTraceId(null);
        setMarkers(selectedMarkers);
    }

    // Busca los puntos cercanos al marcador seleccionado
    const onSearchNearest = () => {
        // Find the selected marker if it exists
        const selectedMarkers = markers.find((marker => {
            if (marker.isSelected) {
                setSelectedMarker(marker);
                return true; // Stop searching once we find the selected marker
            }
            return false;
        }))

        // if no marker is selected, show a toast message and return
        if (!selectedMarkers) {
            showToastCustom(error, "No marker selected. Please select a marker to search for nearest points.");
            return;
        }

        // if more than one marker is selected, show a toast message and return
        if (markers.filter(marker => marker.isSelected).length > 1) {
            showToastCustom(error, "More than one marker selected. Please select only one marker to search for nearest points.");
            return;
        }

        const dataRequest = {
            id: selectedMarkers?.position?.id,
            lat: selectedMarkers?.position?.lat,
            lng: selectedMarkers?.position?.lng,
            ratio: radio,
            udn: {id: udn.id}
        }

        pointService.searchNearest(dataRequest)
            .then( response => {
                console.log("Nearest points response:", response);
                setMarkerOptions(mapResponseToMarkers(response));

                return response
            })
            .catch(e => {
                console.error("Error fetching nearest points:", e);
                showToastCustom(error, "Error fetching nearest points: " + e.message);
                return [];
            })
    }

    const onAltChange = (value, index) => {
        let _markers = markers.slice();
        if (_markers[index]) {
            _markers[index].position.alt = ( value[0] || 0 );
            setMarkers(_markers);
        }
    }

    // Carga un archivo CSV y lo procesa para agregar marcadores
    const onLoadCsv = (e) => {
        let file = e.target.files[0];

        if (file) {
            setFileName(e.target.value)
        }

        let reader = new FileReader();
        reader.onload = function (e) {
            let lines = e.target.result.split('\n');
            let _markers = markers.slice();

            // Ignoramos las primeras 4 líneas ya que contienen metadatos
            for (let i = 4; i < lines.length; i++) {
                let values = lines[i].split(',');

                // Si cualquiera de los valores de las columnas 0, 2 o 3 es NaN, omitimos este registro
                if (isNaN(values[0]) || isNaN(values[2]) || isNaN(values[3])) {
                    continue;
                }

                let _newMarker = {
                    title: "marker" + (_markers.length + 1),
                    name: "marker" + (_markers.length + 1),
                    ratio: 5,
                    showOrder: parseInt(values[0]),
                    position: {lat: parseFloat(values[2]), lng: parseFloat(values[3]), alt: parseFloat(values[4] || 0)},
                }

                _markers.push(_newMarker);
            }

            if (_markers) {
                setMarkers(_markers)

                const mapedPositions = mapFunctions.mapMarkersToPointsArray(_markers, udn);
                setPoints(mapedPositions);
            }
        };

        reader.readAsText(file);
    }

    // Carga un archivo GPX y lo procesa para agregar marcadores
    const onLoadGpx = (e) => {
        let file = e.target.files[0];

        if (file) {
            setFileName(e.target.value);
        }

        let reader = new FileReader();
        reader.onload = function (e) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(e.target.result, "application/xml");

            const trkpts = xmlDoc.getElementsByTagName("trkpt");
            let _markers = markers.slice();

            for (let i = 0; i < trkpts.length; i++) {
                const trkpt = trkpts[i];
                const lat = parseFloat(trkpt.getAttribute("lat"));
                const lon = parseFloat(trkpt.getAttribute("lon"));
                const ele = parseFloat(trkpt.getElementsByTagName("ele")[0]?.textContent || 0);
                const time = trkpt.getElementsByTagName("time")[0]?.textContent || "";

                let _newMarker = {
                    title: "marker" + (_markers.length + 1),
                    name: "marker" + (_markers.length + 1),
                    ratio: 5,
                    showOrder: _markers.length + 1,
                    position: { lat, lng: lon, alt: ele },
                    time: time
                };

                _markers.push(_newMarker);
            }

            if (_markers) {
                setMarkers(_markers);

                const mapedPositions = mapFunctions.mapMarkersToPointsArray(_markers, udn);
                setPoints(mapedPositions);
            }
        };

        reader.readAsText(file);
    };

    const onExport = () => {
        if (!markers || markers.length === 0) {
            showToastCustom(error, "No markers available to export.");
            return;
        }

        const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
        const csvHeaders = "Location,Time,Latitude,Longitude,Altitude,Accuracy(m),Speed(m/s),Bearing\n";
        const csvRows = markers.map((marker, index) => {
            const { lat, lng, alt } = marker.position;
            const time = marker.time || `${today}T00:00:00.000Z`; // Use marker time or default to today
            return `${index + 1},${time},${lat},${lng},${alt || 0},0,0,0`;
        });

        const csvContent = csvHeaders + csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "markers.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Función para calcular la distancia entre dos puntos geográficos
    const haversineDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371e3; // radio de la Tierra en metros
        const a1 = lat1 * Math.PI / 180; // φ, λ en radianes
        const a2 = lat2 * Math.PI / 180;
        const d1 = (lat2 - lat1) * Math.PI / 180;
        const d2 = (lon2 - lon1) * Math.PI / 180;

        const a = Math.sin(d1 / 2) * Math.sin(d1 / 2) +
            Math.cos(a1) * Math.cos(a2) *
            Math.sin(d2 / 2) * Math.sin(d2 / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // en metros
    }

    const smoothCurve = () => {
        let _markers = markers.slice();
        let newMarkers = [];

        for (let i = 0; i < _markers.length - 1; i++) {
            let p0 = _markers[i];
            let p1 = _markers[i + 1];

            let q = {
                title: "marker" + newMarkers.length,
                name: "marker" + newMarkers.length,
                showOrder: newMarkers.length + 1,
                position: {
                    lat: 0.75 * p0.position.lat + 0.25 * p1.position.lat,
                    lng: 0.75 * p0.position.lng + 0.25 * p1.position.lng,
                    alt: p0.position.alt // Mantener la altitud del punto original
                }
            };

            let r = {
                title: "marker" + (newMarkers.length + 1),
                name: "marker" + (newMarkers.length + 1),
                showOrder: newMarkers.length + 2,
                position: {
                    lat: 0.25 * p0.position.lat + 0.75 * p1.position.lat,
                    lng: 0.25 * p0.position.lng + 0.75 * p1.position.lng,
                    alt: p1.position.alt // Mantener la altitud del punto original
                }
            };

            // Solo agregar los nuevos puntos si la distancia es mayor que 2 metros
            if (newMarkers.length === 0 || haversineDistance(newMarkers[newMarkers.length - 1].position.lat, newMarkers[newMarkers.length - 1].position.lng, q.position.lat, q.position.lng) > smoothingDistance) {
                newMarkers.push(q);
            }

            if (haversineDistance(newMarkers[newMarkers.length - 1].position.lat, newMarkers[newMarkers.length - 1].position.lng, r.position.lat, r.position.lng) > smoothingDistance) {
                newMarkers.push(r);
            }
        }

        setMarkers(newMarkers);
    }

    const invertMarkersOrder = () => {
        let _markers = markers.slice();
        let newMarkers = [];

        for (let i = _markers.length - 1; i >= 0; i--) {
            newMarkers.push({
                ..._markers[i],
                showOrder: newMarkers.length
            });
        }

        setMarkers(newMarkers);
    }

    const getPerpendicularDistance = (point, lineStart, lineEnd) => {
        const area = Math.abs(0.5 * (lineStart.position.lat * lineEnd.position.lng + lineEnd.position.lat * point.position.lng +
            point.position.lat * lineStart.position.lng - lineEnd.position.lat * lineStart.position.lng - point.position.lat * lineEnd.position.lng - lineStart.position.lat * point.position.lng));
        const bottom = Math.hypot(lineStart.position.lat - lineEnd.position.lat, lineStart.position.lng - lineEnd.position.lng);
        return area / bottom * 2;
    };

    const simplifySection = (points, startIndex, endIndex, epsilon, simplifiedPoints) => {
        let maxDistance = 0;
        let index;

        for (let i = startIndex + 1; i < endIndex; i++) {
            const distance = getPerpendicularDistance(points[i], points[startIndex], points[endIndex]);

            if (distance > maxDistance) {
                index = i;
                maxDistance = distance;
            }
        }

        if (maxDistance > epsilon) {
            simplifySection(points, startIndex, index, epsilon, simplifiedPoints);
            simplifySection(points, index, endIndex, epsilon, simplifiedPoints);
        } else {
            if (simplifiedPoints[simplifiedPoints.length - 1] !== points[startIndex]) {
                simplifiedPoints.push(points[startIndex]);
            }
            simplifiedPoints.push(points[endIndex]);
        }
    };

    const reduceResolution = () => {
        let _markers = markers.slice();
        let simplifiedMarkers = [];

        simplifySection(_markers, 0, _markers.length - 1, epsilon, simplifiedMarkers);

        setMarkers(simplifiedMarkers);
    };

    const mapResponseToMarkers = (response) => {
        return response.map((item, index) => ({
            title: `near_marker${index + 1}`,
            name: `near_marker${index + 1}`,
            showOrder: index + 1,
            position: {
                lat: item.lat,
                lng: item.lng,
                alt: item.alt || 0, // Default altitude to 0 if not provided
                id: item.id || null // Include ID if available
            },
            time: item.time || '', // Default time to an empty string if not provided
            isSelected: false // Default to not selected
        }));
    }

    const mapMarkersToPositions = (markers) => {
        return markers.map(marker => ({
            lat: marker.position.lat,
            lng: marker.position.lng,
            alt: marker.position.alt || 0,
            time: marker.time || '',
            isSelected: marker.isSelected
        }));
    }

    const mapPositionToMarkers = (positions) => {
        const mappedMarkers = positions.map((position, index) => ({
            title: `marker${index + 1}`,
            name: `marker${index + 1}`,
            showOrder: index + 1,
            position: {
                lat: position.lat,
                lng: position.lng,
                alt: position.alt || 0, // Default altitude to 0 if not provided
            },
            time: position.time || '', // Default time to an empty string if not provided
        }));

        setMarkers(mappedMarkers); // Update the markers state
    };

    const onZoomChange = (newZoom) => {
        setZoom(newZoom);
    }

    // <FontAwesomeIcon icon="fa-solid fa-bezier-curve" />
    // console.log("TraceForm", selectedMarker);
    return (<>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Card className={'card-modal trace-map-form'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="far fa-edit mr-2"/>{FORM}
                        <div className="float-right">
                            <GenericButton
                                style={'table'}
                                label={'Nuevo desde selección'}
                                toolTip={'Inicia un nuevo trazo desde el/los punto(s) seleccionados'}
                                icon={'fa-solid fa-code-branch'}
                                permission={'add'}
                                onClick={onNewFromSelection}
                            />
                            <GenericButton
                                style={'table'}
                                label={'Buscar cercanos'}
                                toolTip={'Busca los puntos cercanos a un punto seleccionado.'}
                                icon={'fa-solid fa-tower-broadcast'}
                                permission={'add'}
                                onClick={onSearchNearest}
                            />
                            <GenericButton
                                style={'table'}
                                label={'CSV'}
                                toolTip={'Exportar a csv'}
                                icon={'fa-download'}
                                permission={'add'}
                                onClick={onExport}
                            />
                            <GenericButton
                                style={'table'}
                                label={showPoints ? 'Ocultar listado lateral' : 'Mostrar listado lateral'}
                                toolTip={'Mostrar/Ocultar listado de puntos'}
                                icon={!showPoints ? 'fa-eye' : 'fa-eye-slash'}
                                permission={'add'}
                                onClick={_ => setShowPoints(!showPoints)}
                            />
                            <GenericButton
                                style={'table'}
                                label={'Vaciar lista'}
                                toolTip={'Remueve todos los puntos de la lista'}
                                icon={'fa-trash'}
                                permission={'add'}
                                onClick={onClearMarkers}
                            />
                            <GenericButton
                                style={'table'}
                                label={'Reducir resolución'}
                                toolTip={'Reducir resolución'}
                                icon={'fa-wave-square'}
                                permission={'add'}
                                onClick={reduceResolution}
                            />
                            <GenericButton
                                style={'table'}
                                label={'Suavizar curva'}
                                toolTip={'Suavizar curva'}
                                icon={'fa-bezier-curve'}
                                permission={'add'}
                                onClick={smoothCurve}
                            />
                            <GenericButton
                                style={'table'}
                                label={'Invertir lista'}
                                toolTip={'Invertir lista'}
                                icon={'fa-exchange'}
                                permission={'add'}
                                onClick={invertMarkersOrder}
                            />
                            <Separator />
                            <GenericButton
                                style={'table'}
                                toolTip={TT_SAVE}
                                icon={'fa-save'}
                                permission={'add'}
                                type={'submit'}
                            />
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={onClose}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                        <Row id={'params'}>
                            {/*<Col md="3" sm={'8'}>*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label>{"Epsilon"}</Label>*/}
                            {/*        <Input type="number"*/}
                            {/*               name="epsilon"*/}
                            {/*               min={0}*/}
                            {/*               max={1}*/}
                            {/*               step={.000001}*/}
                            {/*               value={epsilon}*/}
                            {/*               onChange={e => setEpsilon(parseFloat(e.target.value))}*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            {/*<Col md="3" sm={'8'}>*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label>{ "Radio de influencia de cada punto (metros)" }</Label>*/}
                            {/*        <Input type="number"*/}
                            {/*               name="radio"*/}
                            {/*               min={0}*/}
                            {/*               max={1000}*/}
                            {/*               step={1}*/}
                            {/*               value={radio}*/}
                            {/*               onChange={e => setRadio(parseInt(e.target.value))}*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}

                            {/*<Col md="6">*/}
                            {/*    <FormGroup>*/}
                            {/*        <SelectMultipleGeneric*/}
                            {/*            title={ 'Caracteristicas / Atributos' }*/}
                            {/*            initialValues={ attributes }*/}
                            {/*            setExternalValue={ setAttributes }*/}
                            {/*            provider={ paramSettingsProvider }*/}
                            {/*            customFilter={ { ps_key: 'xkynet_config_trace_types' } }*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            {/*<Col md="4">*/}
                            {/*    <FormGroup>*/}
                            {/*        <SelectGeneric*/}
                            {/*            title={ 'Tipo de linea' }*/}
                            {/*            initialValues={ lineStyle }*/}
                            {/*            setExternalValue={ setLineStyle }*/}
                            {/*            provider={ paramSettingsProvider }*/}
                            {/*            customFilter={ { ps_key: 'xkynet_config_trace_line_styles' } }*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            {/*<Col md="1">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label>{ "Zoom" }</Label>*/}
                            {/*        <Input type="number"*/}
                            {/*               name="zoom"*/}
                            {/*               min={0}*/}
                            {/*               max={1000}*/}
                            {/*               step={1}*/}
                            {/*               value={zoom}*/}
                            {/*               onChange={e => setZoom(parseInt(e.target.value))}*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col md="1" >
                                <FormGroup>
                                    <Label htmlFor="status">Activo</Label><br/>
                                    <Switch animate={true} offText={"No"} onText={"Si"}
                                            value={status}
                                            onChange={_ => setStatus(!status)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="1">
                                <FormGroup>
                                    <Label>{FL_COLOR}</Label>
                                    <Input
                                        type="color"
                                        name="color"
                                        defaultValue={trace?.color || '#b500c2'}
                                        innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="1">
                                <FormGroup>
                                    <Label>{"Radio de busqueda"}</Label>
                                    <Input type="number"
                                           name="radio"
                                           min={0}
                                           max={1000}
                                           step={1}
                                           value={radio}
                                           onChange={e => setRadio(parseInt(e.target.value))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{'Importar trazo desde archivo .csv'}</Label>
                                    <div className="custom-file">
                                        <Input
                                            type="file"
                                            name="img"
                                            className="custom-file-input"
                                            accept="csv"
                                            required={false}
                                            onChange={onLoadCsv}
                                        />
                                        <label className="custom-file-label is-invalid"
                                               htmlFor="inputGroupFile01">{fileName ? fileName : 'Elegir archivo CSV'}</label>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{'Importar trazo desde archivo .gpx'}</Label>
                                    <div className="custom-file">
                                        <Input
                                            type="file"
                                            name="importGpx"
                                            className="custom-file-input"
                                            accept="gpx"
                                            required={false}
                                            onChange={onLoadGpx}
                                        />
                                        <label className="custom-file-label is-invalid"
                                               htmlFor="inputGroupFile01">{fileName ? fileName : 'Elegir archivo GPX'}</label>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row id={'height-sliders'}>
                            {/* Marker heights */}
                            <Col md={"12"}  style={{ height: "120px" }}>

                                <div style={{ overflowY: "scroll", display:"flex" }}>
                                    {
                                        markers.map((marker, index) => (
                                            <div style={style}>
                                                <Slider
                                                    range={{draggableTrack: true}}
                                                    vertical
                                                    min={-5}
                                                    max={30}
                                                    marks={{
                                                        0: <strong>0</strong>,
                                                        // 5: '5',
                                                        10: '10',
                                                        // 15: '15',
                                                        20: '20',
                                                        // 25: '25',
                                                    }}
                                                    onChange={value => onAltChange(value, index)}
                                                    defaultValue={[marker?.position?.alt]}
                                                />
                                            </div>
                                            ))
                                    }
                                </div>
                            </Col>
                        </Row>
                        <Row id={'map-container'} style={{ flexGrow: 1, overflow: "hidden" }} >
                            <Col md={showPoints ? "10" : "12"}>
                                {
                                    googleConfig?.mapOptions !== undefined &&
                                    <MapControllerV2 mode={'TRACE'}
                                                     onMapClick={onMapClick}
                                                     onMarkerClick={onMarkerClick}
                                                     setMarkers={mapPositionToMarkers}
                                                     onZoomChange={onZoomChange}

                                                     markerOptions={mapMarkersToPositions(markerOptions)}
                                                    onMarkerOptionClick={onMarkerOptionClick}

                                                   mapOptions={googleConfig?.mapOptions}
                                                   markers={mapMarkersToPositions(markers)}
                                                   selectedMarker={selectedMarker}
                                    />
                                }
                            </Col>
                            {
                                showPoints &&
                                <Col md="2" className={'position-list'}>
                                    <Label>Puntos selecionados</Label>
                                    <DragList
                                        items={markers}
                                        renderContent={pointDraggableItemContent}
                                        onReorder={onReorder}
                                        onRemoveFromList={onRemoveFromList}
                                        onRemove={onRemovePoint}
                                        onSelect={onSelect}
                                    />
                                </Col>
                            }
                        </Row>
                    </CardBody>
                </Card>
            </Form>
        </>

    )
}

TraceForm.propTypes = {
    // Variables
    fbDataBaseId: PropTypes.string.isRequired,
    // Objetos
    udn: PropTypes.object.isRequired,
    // Metodos
    onClose: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
};